module.exports = __webpack_public_path__ + "static/media/marketing.ce67b3a1.jpg";